import React from 'react'

import PostWidget from 'shared/components/community/components/PostWidget'
import LoadMoreButton from 'shared/components/community/components/post/load-more-button/LoadMoreButton'
import { LoadingSpinner } from '@elo-kit/components/loading-spinner/LoadingSpinner'

import { SIZES } from '@elo-kit/constants/general.constants'

import { withStores } from 'utils/helpers.utils'

const PostsWidget = (props) => {
  const { communityId, communityPostsStore, isPayerCabinet } = props
  const {
    list: communityPostsList,
    pagination: { total: totalCommunityPosts } = {},
    loadMoreButtonLoading,
    handleLoadMorePosts,
  } = communityPostsStore

  const postsLength = communityPostsList.length
  const showLoadMorePosts = !!postsLength && totalCommunityPosts > postsLength

  const loadMoreButtonContent = loadMoreButtonLoading ? (
    <LoadingSpinner
      size={SIZES.extraSmall}
      className='loading-spinner__medium-container'
      loaderClassName='loading-spinner__loader--10-margin'
    />
  ) : (
    <button>{I18n.t('react.shared.community.button.load_more_posts')}</button>
  )

  return (
    <>
      {communityPostsList?.map((post) => (
        <PostWidget
          key={post.id}
          {...{
            post,
            communityId,
            isPayerCabinet,
          }}
        />
      ))}
      {showLoadMorePosts && (
        <LoadMoreButton
          button={loadMoreButtonContent}
          onClick={() => {
            if (loadMoreButtonLoading) {
              return
            }
            handleLoadMorePosts(communityId)
          }}
          hoveredPostButton={!loadMoreButtonLoading}
          isPost
        />
      )}
    </>
  )
}

export default withStores(['communityPostsStore'], PostsWidget)
